/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsx jsx */
import { css } from '@emotion/react'
import heading from './heading.js'

export default css`
  ${heading};
  color: var(--color-primary);
`
